<template>
  <div class="shadow-none">
    <div class="">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div class="mb-[16px]">
          <button
            class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB]"
          >
            End Of Day Report
          </button>
        </div>
        <div
          class="max-w-[400px] w-full flex items-center gap-[48px] cursor-pointer"
          @click="toggleSwitch"
        >
          <div class="flex gap-[12px] items-center">
            <img src="/assets/icon/EOD.svg" class="w-[48px] h-[48px]" />
            <p class="text-[#353535] font-medium leading-[19.36px] text-[16px]">
              Configure Daily EOD report
            </p>
          </div>
          <div>
            <button
              type="button"
              class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer"
              role="switch"
              :aria-checked="Active"
              :class="{
                'bg-[#2463eb]': Active,
                'bg-[#E4E4E7]': !Active,
              }"
            >
              <span
                aria-hidden="true"
                class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                :class="{
                  'translate-x-5': Active,
                  'translate-x-0': !Active,
                }"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-[32px]">
      <p
        v-if="recipientCount > 0"
        class="text-[16px] leading-[16px] font-semibold text-[#353535] mb-[16px]"
      >
        You currently have {{ recipientCount }} EOD recipients
      </p>
      <div class="table-responsive">
        <table class="table dataTable m-0 p-0 text-nowrap">
          <thead class="bg-white" v-if="recipientCount > 0">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-if="loading">
              <td colspan="12" class="text-center">
                <div
                  class="text-center"
                  style="padding-top: 100px; padding-bottom: 50px"
                >
                  <span
                    class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                    style="font-size: 8rem"
                  ></span>
                  <h3
                    class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                    style="padding-bottom: 100px"
                  >
                    Please wait while we load the list
                  </h3>
                </div>
              </td>
            </tr>
            <tr
              v-for="recipients in EDOreportsettingData"
              :key="recipients.id"
              v-else
            >
              <td>{{ recipients.name }}</td>
              <td>{{ recipients.email }}</td>
              <td>
                {{ recipients.role == null ? "Nill" : recipients.role }}
              </td>

              <td>
                <span
                  class="text-[14px] font-medium leading-[20px]"
                  v-if="hasPermission('EndOfDay_Report_Setting_Update')"
                  @click.prevent="deleteEOD(recipients.id)"
                  :class="recipients.active ? 'text-delete' : 'text-add'"
                >
                  {{ recipients.active ? "Delete" : "+ Add" }}
                </span>
              </td>
            </tr>
            <tr v-if="EDOreportsettingData.length == 0 && !loading">
              <td
                colspan="7"
                class="flex w-full flex-col gap-[16px] items-center justify-center"
              >
                <div
                  class="text-center"
                  style="padding-top: 100px; padding-top: 100px;"
                >
                  <img src="/assets/img/EOD.png" alt="" />
                </div>
                <p
                  class="text-[14px] text-[#96A0B5]"
                  style="padding-bottom: 100px"
                >
                  You haven't configured End Of Day <br />
                  Report. Turn on the toggle to do so
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination
          :limit="pageSize"
          :count="pageCount"
          :page="pageNumber"
          :itemsCount="count"
          @changePage="gotoPage"
          @changeLimit="changeLimit"
        />
      </div>
    </div>

    <div class="modal fade" id="mod-edit-EOD" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content modal-content rounded-none bg-[#f8f8f8] p-[20px] md:p-[40px] min-h-screen"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Edit EOD Reports
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Time</label
              >
              <div>
                <select2
                  :disabled="!isActive"
                  placeholder="Select an option"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
                  v-model="editEOD.time"
                >
                  <option value="" selected disabled hidden
                    >Select Option</option
                  >
                  <option
                    :key="option.key"
                    v-for="option in timeRange"
                    :value="option.value"
                    >{{ option.text }}</option
                  >
                </select2>
                <div v-if="v1.time" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">Select time</p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Send to</label
              >
              <div>
                <v-select
                  id="roleSelector"
                  class="style-chooser"
                  multiple
                  :disabled="!isActive"
                  :options="roleOptions"
                  v-model="editEOD.role"
                  :reduce="(value) => value.id"
                  @input="isSelectRole($event)"
                />
                <div v-if="v1.role" class="parsley-errors-list filled">
                  <p class="text-danger error-text ">Select role</p>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <div
                class="flex items-center gap-[10px] max-w-max"
                @click="isActive = !isActive"
              >
                <button
                  type="button"
                  class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                  role="switch"
                  :aria-checked="isActive"
                  :class="{
                    'bg-[#2463eb]': isActive,
                    'bg-[#E4E4E7]': !isActive,
                  }"
                >
                  <span
                    aria-hidden="true"
                    class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                    :class="{
                      'translate-x-5': isActive,
                      'translate-x-0': !isActive,
                    }"
                  ></span>
                </button>
                <span class="cursor-pointer">
                  <span
                    class="text-[#353535] text-[16px] font-normal leading-[20px]"
                  >
                    Send Daily EOD Report
                  </span>
                </span>
              </div>
            </div>
            <div
              :key="`input-${index}`"
              v-for="(input, index) in editEOD.userEmail"
            >
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Add Name(optional)</label
                >
                <div>
                  <input
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    :disabled="!isActive"
                    placeholder="Enter Name"
                    type="text"
                    v-model="input.name"
                  />
                </div>
              </div>
              <div class="pb-[16px]">
                <label
                  class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >Enter Email</label
                >
                <div>
                  <input
                    :disabled="!isActive"
                    class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                    placeholder="Enter Email"
                    type="email"
                    v-model="input.email"
                  />
                </div>
              </div>
            </div>
            <div class="mt-[24px]">
              <div
                class="text-primary cursor-pointer"
                @click.prevent="addFields()"
              >
                <i class="fa fa-plus "></i>
                <span class="text-[#2463EB] text-[14px] font-medium"
                  >&nbsp; &nbsp;Add another Email Address
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              @click.prevent="closeEODModal"
            >
              Cancel
            </button>
            <button
              :disabled="isLoading || !Active"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              type="button"
              @click.prevent="updateEOD"
            >
              <span v-if="isLoading">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Pagination from "../components/Pagination.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "EODReport",
  components: { Select2, vSelect, Pagination },
  data() {
    return {
      isActive: true,
      loading: false,
      isLoading: false,
      Active: false,
      showModal: false,
      isBusy: false,
      isBusyModal: false,
      count: 0,
      page: 0,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      helperisBusy: false,
      systemSettings: null,
      EDOreportsettingData: [],
      isActiveClass: "on-switch",
      isNotActiveClass: "off-switch",
      recipientCount: null,
      hideTable: false,
      roleOptions: [],
      timeRange: [
        { value: 0, text: "Morning" },
        { value: 1, text: "Afternoon" },
        { value: 2, text: "Evening" },
      ],
      roles: [],
      editEOD: {
        active: false,
        time: "",
        role: [],
        name: "",
        userEmail: [],
      },
      v1: {
        active: false,
        time: false,
        role: false,
        name: false,
      },
    };
  },
  created() {
    if (!this.hasPermission("EndOfDay_Report_Setting_View")) {
      this.$router.push("/restricted");
    }
    this.getRoles();
    this.getSystemSettings();
    this.getEndOfDayReportSettings();
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  watch: {
    EDOreportsettingData(newData) {
      this.Active = newData.length > 0;
    },
  },
  methods: {
    toggleTable() {
      this.hideTable = !this.hideTable;
    },
    isSelectRole(e) {
      this.editEOD.role = e;
    },
    toggleSwitch() {
      this.editEODModal();
      this.isActive = true;
    },
    async closeEODModal() {
      await this.getEndOfDayReportSettings();
      this.Active = false;
      $("#mod-edit-EOD").modal("hide");
    },
    editEODModal() {
      $("#mod-edit-EOD").modal("show");
    },
    addFields() {
      this.editEOD.userEmail.push({});
    },
    removeFields(index, products) {
      products.splice(index, 1);
    },
    async getRoles() {
      await this.$http
        .get(
          "/roles/getRoleListNoPaging?parentId=" +
            this.user.parentId +
            "&roleType=" +
            this.user.type
        )
        .then(function(res) {
          this.roleOptions = res.body.map((role, index) => ({
            label: role.text,
            id: role.id,
          }));
        })
        .catch(function() {});
    },
    async updateEOD() {
      this.isBusy = true;
      this.isLoading = true;
      let body = {
        id: this.systemSettings.id ? this.systemSettings.id : "",
        parentId: this.user.parentId,
        active: this.isActive,
        time: this.editEOD.time ? Number(this.editEOD.time) : 0,
        roles: this.editEOD.role.length > 0 ? this.editEOD.role : [],
        optionalRecipient:
          this.editEOD.userEmail.length > 0 ? this.editEOD.userEmail : [],
      };
      try {
        const response = await this.$http.put(
          `/SystemSettings/updateEndOfDayReportSettings/${this.systemSettings.id}`,
          body
        );

        if (response.ok) {
          this.$toast.success("EOD Updated successfully", {
            icon: false,
            rtl: false,
          });
          $("#mod-edit-EOD").modal("hide");
          this.isBusy = false;
          this.isLoading = false;
          await this.getRoles();
          await this.getSystemSettings();
          await this.getEndOfDayReportSettings();
          this.updateState(this.editEOD);
        }
      } catch (err) {
        console.log(err);
        this.isBusy = false;
        this.isLoading = false;
        this.updateState(this.editEOD);
      }
    },
    async deleteEOD(id) {
      this.isBusy = true;
      await this.$http
        .put(
          `/SystemSettings/addRemoveEndOfDayReportRecipient/${id}/${this.user.parentId}`
        )
        .then(function(res) {
          if (res.ok) {
            this.$toast.success("EOD Updated successfuly", {
              icon: false,
              rtl: false,
            });
            $("#mod-edit-EOD").modal("hide");
            this.isBusy = false;
            this.updateState(this.editEOD);
            this.getEndOfDayReportSettings();
          }
        })
        .catch(function(err) {
          if (err) {
            this.isBusy = false;
            this.updateState(this.editEOD);
          }
        });
    },
    updateState(formType) {
      (formType.active = null),
        (formType.time = null),
        (formType.role = []),
        (formType.userEmail = []),
        (formType.name = null);
    },
    async getEndOfDayReportSettings() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          `/SystemSettings/getEndOfDayReportSettings/${
            this.user.parentId
          }?page=${this.pageNumber - 1}&pageSize=${this.pageSize}`
        )
        .then(function(res) {
          this.EDOreportsettingData = res.data.reportRecipients.data;
          this.recipientCount = res.data.reportRecipients.count;
          this.isActive = res.data.active;
          this.editEOD.time = res.data.time;
          this.editEOD.role = res.data.roles;
          this.isBusy = false;
          this.pageNumber = res.data.reportRecipients.pageNumber + 1;
          this.pageSize = res.data.reportRecipients.pageSize;
          this.count = res.data.reportRecipients.count;
          this.pageCount = Math.ceil(
            res.data.reportRecipients.count / res.data.reportRecipients.pageSize
          );
          this.hasPrev = res.data.reportRecipients.hasPrev;
          this.hasNext = res.data.reportRecipients.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      this.isBusy = false;
    },
    async getSystemSettings() {
      this.isBusy = true;
      await this.$http
        .get(
          "/SystemSettings/getList?page=0" +
            "&pageSize=10" +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function(res) {
          this.systemSettings = res.body.data[0];
          this.isBusy = false;
        })
        .catch(function() {});

      this.isBusy = false;
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatDateWithTime(date) {
      return moment(date).format("lll");
    },
    gotoPage(page) {
      this.pageNumber = page;
      this.getEndOfDayReportSettings();
    },
    changeLimit(limit) {
      this.pageSize = limit;
      this.getEndOfDayReportSettings();
    },
    prev() {
      this.pageNumber -= 1;
      this.getEndOfDayReportSettings();
    },
    next() {
      this.pageNumber += 1;
      this.getEndOfDayReportSettings();
    },
  },
};
</script>
<style>
.style-chooser {
  --vs-actions-padding: 12px 14px 12px 14px;
}
.text-delete {
  color: #dc2828;
  cursor: pointer;
}
.text-add {
  color: #2463eb;
  cursor: pointer;
}
</style>
